import type { PatternBridgeLevel } from "./types";

export const PATTERN_BRIDGE_LEVELS: readonly PatternBridgeLevel[] = [
  {
    id: "math-pattern-bridge-1",
    domain: "math",
    activityType: "pattern-bridge",
    difficulty: 1,
    objectives: ["发现两种图案交替的规律"],
    title: "叶子橡果桥",
    instruction: "叶子、橡果，叶子……小桥空了一格。接下来是谁呢？",
    promptAudio: "/audio/voice/math/pattern-bridge-1.ogg",
    assets: [],
    payload: {
      mode: "sequence",
      repeatUnit: ["leaf", "acorn"],
      sequence: ["leaf", "acorn", "leaf", null],
      choices: [
        { id: "leaf", token: "leaf" },
        { id: "acorn", token: "acorn" },
        { id: "flower", token: "flower" }
      ],
      correctChoiceId: "acorn"
    }
  },
  {
    id: "math-pattern-bridge-2",
    domain: "math",
    activityType: "pattern-bridge",
    difficulty: 2,
    objectives: ["发现两个相同图案和一个不同图案的规律"],
    title: "蘑菇叶子桥",
    instruction: "蘑菇、蘑菇、叶子，又开始一轮啦。空位里该放谁？",
    promptAudio: "/audio/voice/math/pattern-bridge-2.ogg",
    assets: [],
    payload: {
      mode: "sequence",
      repeatUnit: ["mushroom", "mushroom", "leaf"],
      sequence: ["mushroom", "mushroom", "leaf", "mushroom", null, "leaf"],
      choices: [
        { id: "leaf", token: "leaf" },
        { id: "flower", token: "flower" },
        { id: "mushroom", token: "mushroom" }
      ],
      correctChoiceId: "mushroom"
    }
  },
  {
    id: "math-pattern-bridge-3",
    domain: "math",
    activityType: "pattern-bridge",
    difficulty: 3,
    objectives: ["补全一个图案后接两个相同图案的规律"],
    title: "星星贝壳桥",
    instruction: "星星后面跟着两只贝壳。照着规律，空位里该是谁？",
    promptAudio: "/audio/voice/math/pattern-bridge-3.ogg",
    assets: [],
    payload: {
      mode: "sequence",
      repeatUnit: ["star", "shell", "shell"],
      sequence: ["star", "shell", "shell", "star", null, "shell"],
      choices: [
        { id: "shell", token: "shell" },
        { id: "star", token: "star" },
        { id: "flower", token: "flower" }
      ],
      correctChoiceId: "shell"
    }
  },
  {
    id: "math-pattern-bridge-4",
    domain: "math",
    activityType: "pattern-bridge",
    difficulty: 4,
    objectives: ["补全三种图案依次重复的规律"],
    title: "三朵花纹桥",
    instruction: "叶子、花朵、橡果排着队。找找空位少了谁。",
    promptAudio: "/audio/voice/math/pattern-bridge-4.ogg",
    assets: [],
    payload: {
      mode: "sequence",
      repeatUnit: ["leaf", "flower", "acorn"],
      sequence: ["leaf", "flower", "acorn", "leaf", null, "acorn"],
      choices: [
        { id: "acorn", token: "acorn" },
        { id: "flower", token: "flower" },
        { id: "leaf", token: "leaf" }
      ],
      correctChoiceId: "flower"
    }
  },
  {
    id: "math-pattern-bridge-5",
    domain: "math",
    activityType: "pattern-bridge",
    difficulty: 5,
    objectives: ["在方格中按两个方向找到终点"],
    title: "两步过桥",
    instruction: "先跟着点点走一遍：向上，再向右。现在轮到你，小船会停在哪一格？",
    promptAudio: "/audio/voice/math/pattern-bridge-5.ogg",
    assets: [],
    payload: {
      mode: "route",
      columns: 3,
      rows: 3,
      start: { column: 1, row: 2 },
      moves: ["up", "right"],
      choices: [
        { id: "middle", position: { column: 1, row: 1 } },
        { id: "upper-right", position: { column: 2, row: 1 } },
        { id: "lower-right", position: { column: 2, row: 2 } }
      ],
      correctChoiceId: "upper-right"
    }
  },
  {
    id: "math-pattern-bridge-6",
    domain: "math",
    activityType: "pattern-bridge",
    difficulty: 6,
    objectives: ["在方格中按四个方向步骤找到终点"],
    title: "弯弯小路桥",
    instruction: "先看清这条小路：上、右、右、上。跟着走一遍，终点在哪里？",
    promptAudio: "/audio/voice/math/pattern-bridge-6.ogg",
    assets: [],
    payload: {
      mode: "route",
      columns: 4,
      rows: 3,
      start: { column: 0, row: 2 },
      moves: ["up", "right", "right", "up"],
      choices: [
        { id: "top-middle", position: { column: 2, row: 0 } },
        { id: "top-left", position: { column: 1, row: 0 } },
        { id: "center-right", position: { column: 2, row: 1 } }
      ],
      correctChoiceId: "top-middle"
    }
  }
];
